import { IPreorderType } from 'my-poppies-b2b-types';

import { colors } from '@/colors';
import { Container } from '@/components/Container';

interface IPreorderTypeBadgeProps {
  type: IPreorderType;
}

export const PreorderTypeBadge = ({ type }: IPreorderTypeBadgeProps) => {
  return (
    <Container
      sx={{
        fontWeight: 'bold',
        backgroundColor: type === 'STANDARD' ? colors.success : colors.error,
        color: type === 'STANDARD' ? colors.white : colors.white,
        padding: '0 4px',
        borderRadius: '4px',
        fontSize: 10,
        width: 'max-content',
        margin: 'unset',
        marginLeft: 'auto',
      }}
    >
      {type}
    </Container>
  );
};
